import { NgModule } from '@angular/core';
import { ProgressSpinnerComponent } from './progress-spinner.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  imports: [MatProgressSpinnerModule, ProgressSpinnerComponent],
  exports: [ProgressSpinnerComponent],
})
export class ProgressSpinnerModule {}
